var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import Icons from './Icons/Icons';
import { formatPrice } from '../utils/utilities';
import SamplesUtil from '../utils/samplesUtil';
import cartUtil from '../utils/cartUtil';
import SpendingTrackerSimple from './ComplimentarySamples/SpendingTrackerSimple';
import Recommendations from './recommendations';
const handleize = (string) => {
    return string.replace(/[^a-z0-9]+/gi, '-').toLowerCase();
};
const ComplimentarySamples = ({ cartItems, totalPrice, updateVariants, firstTierThreshold, secondTierThreshold, firstTierQuantity, secondTierQuantity, firstTierTitle, secondTierTitle, firstTierCost, secondTierCost, itemCount, subtitle, title }) => {
    const [firstTierSamples, setFirstTierSamples] = useState([]);
    const [secondTierSamples, setSecondTierSamples] = useState([]);
    const [selectedSamplesFirst, setSelectedSamplesFirst] = useState([]);
    const [selectedSamplesSecond, setSelectedSamplesSecond] = useState([]);
    const [accordionExpanded, setAccordionExpanded] = useState(true);
    const [updatingSample, setUpdatingSample] = useState(false);
    const [mounted, setMounted] = useState(false);
    let totalPriceFormatted = parseFloat(totalPrice) / 100;
    let showFirstTier = (totalPriceFormatted) >= dataJs.samples.firstTierAmount;
    let showSecondTier = (totalPriceFormatted) >= dataJs.samples.secondTierAmount;
    useEffect(() => {
        SamplesUtil.getSampleProducts('first-tier-samples').then((products) => {
            products = (products || []).map(product => {
                product.tier = 'first';
                return product;
            });
            setFirstTierSamples(products);
        });
        SamplesUtil.getSampleProducts('second-tier-samples').then((products) => {
            products = (products || []).map(product => {
                product.tier = 'second';
                return product;
            });
            setSecondTierSamples(products);
        });
        SamplesUtil.validateSamplesInCart(firstTierThreshold, secondTierThreshold, totalPrice).then((samplesData) => {
            setSelectedSamplesFirst(samplesData.first);
            setSelectedSamplesSecond(samplesData.second);
        });
    }, []);
    useEffect(() => {
        SamplesUtil.validateSamplesInCart(firstTierThreshold, secondTierThreshold, totalPriceFormatted).then((samplesData) => {
            setSelectedSamplesFirst(samplesData.first);
            setSelectedSamplesSecond(samplesData.second);
        });
        if (totalPriceFormatted < firstTierThreshold) {
            setSelectedSamplesFirst([]);
        }
        if (totalPriceFormatted < secondTierThreshold) {
            setSelectedSamplesSecond([]);
        }
    }, [totalPriceFormatted]);
    const handleSelectSample = (selectedSample, e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        e.stopPropagation();
        setUpdatingSample(selectedSample.id);
        let samplesSearch = selectedSample.tier == 'first' ? firstTierSamples : secondTierSamples;
        let sample = (samplesSearch || []).find(sample => sample.id == selectedSample.id);
        if (!sample)
            return;
        yield updateVariants([(sample || {}).variants[0].id], 1);
        if (sample.tier == 'first') {
            setSelectedSamplesFirst([...selectedSamplesFirst, sample]);
        }
        else {
            setSelectedSamplesSecond([...selectedSamplesSecond, sample]);
        }
        setTimeout(() => {
            setUpdatingSample(false);
        }, 100);
    });
    const handleRemoveSample = (sample, e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        e.stopPropagation();
        setUpdatingSample(sample.id);
        let sampleSelected = (cartItems || []).find(item => item.variant_id == ((sample || {}).variants || [])[0].id);
        if (sampleSelected) {
            yield updateVariants([sampleSelected.variant_id], 0);
            SamplesUtil.validateSamplesInCart(firstTierThreshold, secondTierThreshold, totalPrice).then((samplesData) => {
                setSelectedSamplesFirst(samplesData.first);
                setSelectedSamplesSecond(samplesData.second);
            });
        }
        setTimeout(() => {
            setUpdatingSample(false);
        }, 100);
    });
    let thresholdMissingFirst = dataJs.samples.firstTierAmount - totalPriceFormatted;
    let thresholdMissingSecond = dataJs.samples.secondTierAmount - totalPriceFormatted;
    if (thresholdMissingFirst < 0) {
        thresholdMissingFirst = 0;
    }
    else if (thresholdMissingSecond < 0) {
        thresholdMissingSecond = 0;
    }
    let thresholdMissing = showFirstTier ? thresholdMissingFirst : thresholdMissingSecond;
    let thresholdQuantity = showFirstTier ? (showSecondTier ? secondTierQuantity : firstTierQuantity) : secondTierQuantity;
    let thresholdMax = showFirstTier ? (showSecondTier ? secondTierThreshold : firstTierThreshold) : secondTierThreshold;
    let samples = [];
    (firstTierSamples || []).map((sample) => {
        if (selectedSamplesFirst.length >= firstTierQuantity || totalPriceFormatted < firstTierThreshold)
            sample.disabled = true;
        else
            sample.disabled = false;
        samples.push(sample);
    });
    (secondTierSamples || []).map((sample) => {
        if (selectedSamplesSecond.length >= secondTierQuantity || totalPriceFormatted < secondTierThreshold)
            sample.disabled = true;
        else
            sample.disabled = false;
        samples.push(sample);
    });
    return (React.createElement("div", { className: "sidecart-samples" },
        React.createElement("h3", { className: "sidecart-samples__title" },
            title,
            React.createElement("br", null),
            React.createElement("span", { className: "sidecart-samples__subtitle" }, subtitle),
            React.createElement("button", { className: "sidecart-samples__accordion-toggle", onClick: () => setAccordionExpanded(!accordionExpanded) }, accordionExpanded ? React.createElement(Icons.Minus, null) : React.createElement(Icons.Plus, null))),
        React.createElement("div", { className: `sidecart-samples__accordion ${accordionExpanded ? 'sidecart-samples__accordion--expanded' : ''}` },
            React.createElement("span", { className: "sidecart-samples__threshold visually-hidden" },
                React.createElement("span", null,
                    React.createElement("b", null,
                        "You are ",
                        formatPrice(thresholdMissing),
                        " off"),
                    " ",
                    thresholdQuantity,
                    " complimentary samples"),
                React.createElement("span", null,
                    formatPrice(thresholdMax * 100),
                    " spend")),
            React.createElement(SpendingTrackerSimple, { title: "Complimentary Samples", cartTotal: totalPrice / 100, firstTierThreshold: dataJs.samples.firstTierAmount, secondTierThreshold: dataJs.samples.secondTierAmount, firstTierMessage: dataJs.samples.trackerFirstTierIntro, secondTierMessage: dataJs.samples.trackerSecondTierIntro, firstTierLabel: firstTierTitle, secondTierLabel: secondTierTitle, firstTierCost: firstTierCost, secondTierCost: secondTierCost }),
            React.createElement("div", { className: "sidecart-samples__list" }, (samples || []).map((sample, index) => {
                let sampleSelected = (cartItems || []).find(item => item.variant_id == ((sample || {}).variants || [])[0].id);
                let disabled = sample.disabled;
                if (sampleSelected) {
                    disabled = false;
                }
                let sampleTag = sample.tier == 'first' ? 'ft-sample' : 'st-sample';
                sampleTag += `${handleize(sample.title)}`;
                return (React.createElement("div", { className: "sidecart-samples__item", key: index, "data-tier": sample.tier, "data-disabled": disabled, "data-selected": !!sampleSelected },
                    sampleSelected && (React.createElement("div", { className: 'sidecart-samples__item-ticked' },
                        React.createElement(Icons.Tick, null))),
                    React.createElement("div", { className: "sidecart-samples__item-image-container" },
                        React.createElement("img", { className: "sidecart-samples__item-image", src: sample.featured_image.url, alt: sample.featured_image.alt })),
                    React.createElement("div", { className: "sidecart-samples__item-title" }, sample.title),
                    updatingSample == sample.id ? (React.createElement("div", { className: "sidecart-samples__item--loading" },
                        React.createElement(Icons.Loading, null)))
                        :
                            (sampleSelected
                                ? React.createElement("a", { id: sampleTag, className: "sidecart-samples__item-select", onClick: (e) => handleRemoveSample(sample, e) }, "Remove")
                                : React.createElement("a", { id: sampleTag, className: `sidecart-samples__item-select${disabled ? ' sidecart-samples__item-select--disabled' : ''}`, onClick: (e) => handleSelectSample(sample, e) }, "Select")),
                    disabled && (React.createElement("span", { className: "sidecart-samples__item-disabled" },
                        React.createElement(Icons.Padlock, null)))));
            })))));
};
const CartItem = (_a) => {
    var { item, updateCartItems, items, setSecondaryLoading, isSecondaryLoading } = _a, props = __rest(_a, ["item", "updateCartItems", "items", "setSecondaryLoading", "isSecondaryLoading"]);
    const [isLoading, setIsLoading] = useState(false);
    const [includedWithProductKey, setIncludedWithProductKey] = useState(null);
    const [includedWithProductTitle, setIncludedWithProductTitle] = useState(null);
    const [attachedComplimentaryKey, setAttachedComplimentaryKey] = useState(null);
    const isComplimentary = item.properties._complimentary;
    useEffect(() => {
        if (isComplimentary) {
            let foundIncludedWithProduct = items.find(i => i.id == item.properties._complimentary);
            setIncludedWithProductKey((foundIncludedWithProduct || {}).key);
            setIncludedWithProductTitle((foundIncludedWithProduct || {}).product_title);
        }
        else {
            let foundAttachedComplimentary = items.find(i => i.properties._complimentary == item.variant_id);
            setAttachedComplimentaryKey((foundAttachedComplimentary || {}).key);
        }
    }, [items, isComplimentary]);
    const handleRemoveItem = (item) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        let itemsToUpdate = [item];
        if (attachedComplimentaryKey) {
            setSecondaryLoading(attachedComplimentaryKey);
            let attachedComplimentary = items.find(i => i.key == attachedComplimentaryKey);
            itemsToUpdate.push(attachedComplimentary);
        }
        yield updateCartItems(itemsToUpdate, 0);
        setIsLoading(false);
        setSecondaryLoading(null);
    });
    const handleUpdateQuantity = (item, quantity) => __awaiter(void 0, void 0, void 0, function* () {
        if (includedWithProductKey) {
            let includedWithProduct = items.find(i => i.key == includedWithProductKey);
            let includedQuantity = includedWithProduct.quantity;
            if (quantity > includedQuantity) {
                quantity = includedQuantity;
                return;
            }
        }
        setIsLoading(true);
        let itemsToUpdate = [item];
        if (attachedComplimentaryKey) {
            let attachedComplimentary = items.find(i => i.key == attachedComplimentaryKey);
            if (quantity < attachedComplimentary.quantity) {
                setSecondaryLoading(attachedComplimentary.key);
                itemsToUpdate.push(attachedComplimentary);
            }
        }
        yield updateCartItems(itemsToUpdate, quantity);
        setIsLoading(false);
        setSecondaryLoading(null);
    });
    const priceDisplay = (item) => {
        if (!!item.discounted_line_price && item.discounted_line_price < item.original_line_price) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "sidecart-item__cost--original" }, formatPrice(item.original_line_price)),
                React.createElement("span", { className: "sidecart-item__cost--current" }, formatPrice(item.discounted_line_price))));
        }
        if (parseFloat(item.compare_at_price) > item.price) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "sidecart-item__cost--original" }, formatPrice(item.compare_at_price * item.quantity)),
                React.createElement("span", { className: "sidecart-item__cost--current" }, formatPrice(item.price * item.quantity))));
        }
        return (React.createElement("span", null, formatPrice(item.price * item.quantity)));
    };
    return (React.createElement("div", Object.assign({ className: "sidecart-item" }, props),
        React.createElement("div", { className: `sidecart-item__loader ${isLoading || (isSecondaryLoading === item.key) ? 'sidecart-item__loader--active' : ''}` },
            React.createElement("div", { className: "sidecart-item__loader-spinner" },
                React.createElement(Icons.Loading, null))),
        React.createElement("div", { className: "sidecart-item__image" },
            React.createElement("img", { src: item.featured_image.url, alt: item.featured_image.alt })),
        React.createElement("div", { className: "sidecart-item__details" },
            React.createElement("div", { className: "sidecart-item__details-info" },
                React.createElement("a", { href: item.product_url, className: "sidecart-item__details-info__title" }, item.product_title),
                !item.product_has_only_default_variant && (React.createElement("span", { className: "sidecart-item__details-info__options" }, item.variant_options)),
                includedWithProductTitle && (React.createElement("span", { className: "sidecart-item__details-info__included" },
                    "Included with ",
                    includedWithProductTitle))),
            React.createElement("div", { className: "sidecart-item__details-quantity" },
                React.createElement("button", { className: 'sidecart-item__quantity-button', onClick: () => handleUpdateQuantity(item, item.quantity - 1) },
                    React.createElement(Icons.Minus, null)),
                React.createElement("span", { className: 'sidecart-item__quantity-amount' }, item.quantity),
                React.createElement("button", { className: 'sidecart-item__quantity-button', onClick: () => handleUpdateQuantity(item, item.quantity + 1) },
                    React.createElement(Icons.Plus, null)),
                React.createElement("button", { className: 'sidecart-item__remove', onClick: () => handleRemoveItem(item) }, "Remove"))),
        React.createElement("div", { className: "sidecart-item__cost" }, priceDisplay(item))));
};
const SideCart = (props) => {
    const [cart, setCart] = useState(null);
    const [cartOpen, setCartOpen] = useState(false);
    const [secondaryLoading, setSecondaryLoading] = useState(null);
    const [selectedOption, setSelectedOption] = useState({ tag: '', title: '' });
    const footerRef = useRef(null);
    const bundleDataRef = useRef(null);
    let { item_count: itemCount, total_price: totalPrice, items } = cart || {};
    const { upsellTitle, upsellDescription } = props;
    let cartData = Object.assign(Object.assign({}, cart), { total_price: parseFloat((bundleDataRef.current || {}).total_amount_discounted) || parseFloat((cart || {}).total_price), original_total_price: parseFloat((bundleDataRef.current || {}).total_amount_original) || parseFloat((cart || {}).total_price) });
    if (bundleDataRef.current) {
        cartData.items = ((cartData || {}).items || []).map((item) => {
            let bundleDataItem = bundleDataRef.current.discounted_cart_object.items.find((bundleItem) => bundleItem.key == item.key);
            item.original_line_price = (bundleDataItem || {}).original_line_price || item.compare_at_price;
            item.line_price = (bundleDataItem || {}).line_price;
            return item;
        });
    }
    let cartItems = (cartData || {}).items || items;
    useEffect(() => {
        let cartButton = document.querySelector(".header__cart");
        window.addEventListener("cart-updated", updateCartEvent.bind(this));
        window.addEventListener("cart-added-item", addCartEvent.bind(this));
        cartButton.addEventListener("click", toggleCart);
        document.addEventListener('bundler:total_cart_values', initializeBundleDiscount.bind(this));
        initializeCart();
        return () => {
            window.removeEventListener("cart-updated", updateCartEvent.bind(this));
            window.removeEventListener("cart-added-item", addCartEvent.bind(this));
            document.removeEventListener('bundler:total_cart_values', initializeBundleDiscount.bind(this));
            cartButton.removeEventListener("click", toggleCart);
        };
    }, []);
    const getElementHeight = (element) => {
        return element ? (element.getBoundingClientRect() || {}).height : 0;
    };
    const initializeCart = () => __awaiter(void 0, void 0, void 0, function* () {
        let newCart = yield (yield fetch("/cart?view=json-data")).json();
        newCart = Object.assign(Object.assign(Object.assign({}, cart), newCart), { original_total_price: parseFloat(newCart.total_price) });
        setCart(newCart);
    });
    const initializeBundleDiscount = (e) => __awaiter(void 0, void 0, void 0, function* () {
        let bundleData = e.detail;
        let discountedTotal = bundleData.total_amount_discounted;
        let originalTotal = bundleData.total_amount_original;
        if (bundleDataRef.current && bundleDataRef.current.total_amount_discounted == discountedTotal && bundleDataRef.current.total_amount_original == originalTotal) {
            return;
        }
        bundleDataRef.current = bundleData;
    });
    const toggleCart = (e = false) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setCartOpen(!cartOpen);
        document.body.classList.toggle('locked');
        return false;
    };
    const addCartEvent = (event) => __awaiter(void 0, void 0, void 0, function* () {
        yield initializeCart();
        if (!cartOpen) {
            toggleCart(event);
        }
    });
    const updateCartEvent = (event) => {
        initializeCart();
    };
    const updateCartItems = (items, quantity) => __awaiter(void 0, void 0, void 0, function* () {
        let updates = items.reduce((acc, item) => {
            acc[item.id] = quantity;
            return acc;
        }, {});
        yield cartUtil.update(updates);
        initializeCart();
    });
    const updateVariants = (variantIds, quantity) => __awaiter(void 0, void 0, void 0, function* () {
        if (quantity == 0) {
            let updates = variantIds.reduce((acc, id) => {
                acc[id] = 0;
                return acc;
            }, {});
            yield fetch(`/cart/update.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates
                })
            });
            return initializeCart();
        }
        let items = variantIds.map(id => ({ id, quantity }));
        yield fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items
            })
        }).then(res => res.json());
        initializeCart();
    });
    const goToCheckout = () => {
        var _a, _b;
        if (itemCount == 0) {
            toggleCart();
            return;
        }
        if ((_a = window === null || window === void 0 ? void 0 : window.bndlr) === null || _a === void 0 ? void 0 : _a.checkout) {
            (_b = window === null || window === void 0 ? void 0 : window.bndlr) === null || _b === void 0 ? void 0 : _b.checkout();
            return;
        }
        window.location.href = '/checkout';
    };
    let filteredCartItems = (cartItems || []).filter(item => {
        let hideItem = item.product_type == 'Free Gift' || item.product_type == 'First Tier Sample' || item.product_type == 'Second Tier Sample';
        return !hideItem;
    });
    let originalTotalPrice = filteredCartItems.reduce((acc, item) => {
        let price = (item.compare_at_price || item.original_line_price || item.price);
        return acc + (parseFloat(price) * item.quantity);
    }, 0);
    let bundleTotalPrice = (bundleDataRef.current || {}).total_amount_discounted;
    console.log(originalTotalPrice, bundleTotalPrice, cartData.total_price);
    let itemCountComplimentary = (cartItems || []).reduce((acc, item) => {
        if (item.product_type == 'eGift Card' || item.product_type == 'Gift Card') {
            return acc;
        }
        return acc + item.quantity;
    }, 0);
    let cartTotalComplimentary = (cartItems || []).reduce((acc, item) => {
        if (item.product_type == 'eGift Card' || item.product_type == 'Gift Card') {
            return acc;
        }
        return acc + (item.price * item.quantity);
    }, 0);
    return (React.createElement("div", { className: `sidecart ${cartOpen ? 'sidecart--open' : ''}` },
        React.createElement("div", { className: `sidecart-overlay ${cartOpen ? 'sidecart-overlay--active' : ''}`, onClick: toggleCart }),
        React.createElement("div", { className: "sidecart-content" },
            React.createElement("div", { className: "sidecart-content__inner", style: { paddingBottom: getElementHeight(footerRef.current) } },
                React.createElement("div", { className: "sidecart-header" },
                    React.createElement("h3", null,
                        "Cart (",
                        itemCount,
                        ")"),
                    React.createElement("div", { className: "sidecart-header__close", onClick: toggleCart, role: 'button', "aria-label": 'Close cart' },
                        React.createElement(Icons.Close, null))),
                itemCount == 0
                    ? (React.createElement("div", { className: "cart-empty supports-cookies" },
                        React.createElement("h3", { className: "cart-empty__title" }, "You have no items in your cart."))) : (React.createElement("div", { className: 'sidecart-main' },
                    React.createElement("div", { className: "sidecart-items" }, (filteredCartItems || []).map((item, index) => React.createElement(CartItem, { key: item.key, item: item, updateCartItems: updateCartItems, items: cartItems, setSecondaryLoading: setSecondaryLoading, isSecondaryLoading: secondaryLoading === item.key }))),
                    React.createElement(Recommendations, { parentClass: '.sidecart', initializeCart: initializeCart, cartItems: cartItems, cartTotal: (cartItems || []).length, upsellTitle: upsellTitle, upsellDescription: upsellDescription }),
                    itemCountComplimentary > 0 && (React.createElement(ComplimentarySamples, { updateVariants: updateVariants, cartItems: cartItems, totalPrice: cartTotalComplimentary, itemCount: itemCountComplimentary, firstTierThreshold: dataJs.samples.firstTierAmount, secondTierThreshold: dataJs.samples.secondTierAmount, firstTierQuantity: dataJs.samples.firstTierQuantity, secondTierQuantity: dataJs.samples.secondTierQuantity, firstTierTitle: dataJs.samples.firstTierTitle, secondTierTitle: dataJs.samples.secondTierTitle, firstTierCost: dataJs.samples.firstTierMessage, secondTierCost: dataJs.samples.secondTierMessage, subtitle: dataJs.samples.subtitle, title: dataJs.samples.title }))))),
            React.createElement("div", { className: "sidecart-footer", ref: footerRef },
                React.createElement("div", { className: "sidecart-footer__shipping" }, "Complimentary Shipping on all orders"),
                React.createElement("div", { className: "sidecart-footer__subtotal" },
                    React.createElement("span", null, "Subtotal"),
                    React.createElement("span", null, ((originalTotalPrice > (cartData || {}).total_price) || (originalTotalPrice > bundleTotalPrice)) ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "sidecart-footer__subtotal--original" }, formatPrice(originalTotalPrice)),
                        React.createElement("span", { className: "sidecart-footer__subtotal--total" }, formatPrice((cartData || {}).total_price))))
                        :
                            (React.createElement("span", null, formatPrice((cartData || {}).total_price))))),
                React.createElement("button", { className: "button sidecart-submit", onClick: goToCheckout }, itemCount == 0
                    ? (React.createElement("span", null, "Continue Shopping")) : (React.createElement("span", null, "Proceed to Checkout"))),
                React.createElement("span", { className: "sidecart-footer__info" }, "Tax and promo codes calculated at checkout")))));
};
export default SideCart;
